export function partialInit<T>(target: T, source?: Partial<T>): T {

    if (source) {
        const tmp = source as any;
        for (const key of Object.keys(source)) {
            (<any>target)[key] = tmp[key];
        }
    }

    return target;
}
